import maldivesCharterTakeoverConfig from 'takeovers/maldivesCharterTakeover/maldivesCharterTakeoverConfig'

import { TakeoverId } from '../client/lib/lab/dynamicPayload'

export { TakeoverId }

export const takeovers: Record<TakeoverId, App.SiteTakeoverConfig | undefined> = {
  [TakeoverId.MALDIVES_CHARTER_TAKEOVER]: maldivesCharterTakeoverConfig,
} as const
